import { render, staticRenderFns } from "./MyLesson.vue?vue&type=template&id=2f4f7620&scoped=true&"
import script from "./MyLesson.vue?vue&type=script&lang=js&"
export * from "./MyLesson.vue?vue&type=script&lang=js&"
import style0 from "./MyLesson.vue?vue&type=style&index=0&id=2f4f7620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4f7620",
  null
  
)

export default component.exports